export default __webpack_public_path__ + "static/media/3.9093eeb2.jpg";